import React, { useEffect, useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import BtnLight from "../../../../common/element/Buttons/btnLight";
import Button from "../../../../common/element/Buttons";
import BtnPrimary from "../../../../common/element/Buttons/btnPrimary";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ProviderRegisterPaymentInfo } from "../../../../actions/public/ProviderRegisterPaymentInfo";
import Steps from "../../../../common/element/Steps";
import { GetProviderChecklistByClient } from "../../../../actions/provider-portal/registration/GetProviderChecklistByClient";
import { useSelector } from "react-redux";
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";
import Upload from "../../../../common/element/Upload";
import ClientInput from "../../../../common/element/Input/clientInput";
import DatePicker from "../../../../common/element/DatePicker";
import dayjs from "dayjs";
import { AddProviderDocsAndSubmit } from "../../../../actions/provider-portal/registration/AddProviderDocsAndSubmit";
import Card from "../../../../common/element/Card";
import { RegisterExistingProviderForClient } from "../../../../actions/provider-portal/registration/RegisterExistingProviderForClient";
import moment from "moment/moment";
import ThreeDotLoader from "../../../../common/element/ButtonLoader/ThreeDotLoader";
import Dialog from "../../../../common/element/Dialog";
import Select from "../../../../common/element/Select";
import { GetAllIndividualListForWorkerInvites } from "../../../../actions/provider-portal/worker/GetAllIndividualListForWorkerInvites";
import { RegisterWorker } from "../../../../actions/public/RegisterWorker";
import { debounce } from "../../../../common/snippet/Debouncing";
import { useCallback } from "react";
import { notify } from "react-notify-toast";

const InviteClientPaymentExistUser = (props) => {
  const loginUserData = JSON.parse(localStorage.getItem("LoginUserData"));
  const token = localStorage.getItem("conserve_authtoken");
  const [isProcessing, setIsProcessing] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const [useSavedCard, setUseSavedCard] = useState(false)
  const [savedCard, setSavedCard] = useState(null);
  const { ProviderContactData } = useSelector((state) => state);
  const clientPays =
    ProviderContactData?.is_client_pay_licence === true ||
    ProviderContactData?.is_client_pay_licence === "true";
  const [cardExpiredOrNot, setCardExpiredOrNot] = useState(false);
  const { ProviderRegisterFinalData } = useSelector((state) => state);
  const { invite_provider_id } = useParams(); // Gets '183' from the URL
  const dateGap = 0;
  const dispatch = useDispatch();
  const [step, setStep] = useState(0);
  const [checkError, setCheckError] = useState(false);
  const [firstStep, secondStep] = useState(false);
  const [docData, SetDocData] = useState([]);
  const [workerDocData, SetworkerDocData] = useState([]);
  const [providerSubExpired, setProviderSubExipred] = useState(false)
  const [open, setOpen] = useState(0);
  const [complianceData, setComplianceData] = useState({
    client_org_id: "",
    provider_org_id: "",
    docsData: [],
    provider_trading_name: "",
    abn_nzbn: "",
    sub_invoice_id: "",
  });
  const [agree, setAgree] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [checkPayment, setCheckPayment] = useState(true);
  const [saveCard, setSaveCard] = useState(true);
  const [subscriptionDuration, setSubscriptionDuration] = useState("1_year");

  const [paymentData, setPaymentData] = useState(null);
  const [additionalWorkers, setAdditionalWorkers] = useState(0);
  const [workerError, setWorkerError] = useState("");

  // Worker invitation state
  const [providerFunctionAssignmentId, setProviderFunctionAssignmentId] = useState(null);
  const [seatCount, setSeatCount] = useState(0);
  const [invitedWorkersCount, setInvitedWorkersCount] = useState(0);
  const [searchOptions, setSearchOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [search2, setSearch2] = useState("");
  const [addWorkerData, setAddWorkerData] = useState({
    workersInviteData: [
      {
        individual_id: "",
        email: "",
        first_name: "",
        last_name: "",
      },
    ],
  });
  const [errorValidation, setErrorValidation] = useState({
    ...addWorkerData?.workersInviteData?.reduce((acc, _, index) => {
      acc[`firstNameError_${index}`] = "";
      acc[`lastNameError_${index}`] = "";
      acc[`emailError_${index}`] = "";
      acc[`conserveTeamError_${index}`] = "";
      acc[`alreadyWorkerError_${index}`] = "";
      acc[`alreadyInvitedError_${index}`] = "";
      return acc;
    }, {}),
  });
  const [subscriptionStatus, setSubscriptionStatus] = useState("");
  const totalWorker = addWorkerData?.workersInviteData?.length || 0;

  // Zero-amount detection: if total payable is 0, bypass payment UI requirements
  useEffect(() => {
    const computedTotal = (paymentData?.amount !== undefined && paymentData?.amount !== null)
      ? Number(paymentData?.amount)
      : Number(paymentData?.licence_fee || 0) + Number(paymentData?.worker_amount || 0);
    if (!isNaN(computedTotal) && computedTotal === 0) {
      // Do not bypass the payment step UI for provider pays.
      // Only pre-check agreement to enable Continue; the API call will set checkPayment(false) on success.
      setAgree(true);
      try { localStorage.setItem('countpaymentpage', 'zeroAmountExistingBypass'); } catch (e) {}
    }
  }, [paymentData]);

  const onChange = (nextStep) => {
    if (nextStep < 0) {
      setStep(0);
    } else {
      setStep(nextStep);
    }
  };

  // Ensure the Continue button doesn't stay disabled due to a stale processing state
  useEffect(() => {
    if (step !== 0) {
      setIsProcessing(false);
    }
  }, [step]);

  const onPrevious = () => onChange(step - 1);

  // Worker invitation functions
  const addWorker = () => {
    setAddWorkerData((prevState) => {
      const newIndex = prevState.workersInviteData.length;
      
      // Initialize error validation for the new worker
      setErrorValidation((prevErrors) => ({
        ...prevErrors,
        [`firstNameError_${newIndex}`]: "",
        [`lastNameError_${newIndex}`]: "",
        [`emailError_${newIndex}`]: "",
        [`conserveTeamError_${newIndex}`]: "",
        [`alreadyWorkerError_${newIndex}`]: "",
        [`alreadyInvitedError_${newIndex}`]: "",
      }));

      return {
        ...prevState,
        workersInviteData: [
          ...prevState.workersInviteData,
          { individual_id: "", email: "", first_name: "", last_name: "" },
        ],
      };
    });
  };

  const DeleteWorker = (indexToRemove) => {
    setAddWorkerData((prevState) => {
      const updatedWorkersInviteData = prevState.workersInviteData.filter(
        (_, index) => index !== indexToRemove
      );

      setErrorValidation((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[`firstNameError_${indexToRemove}`];
        delete updatedErrors[`lastNameError_${indexToRemove}`];
        delete updatedErrors[`emailError_${indexToRemove}`];
        delete updatedErrors[`conserveTeamError_${indexToRemove}`];
        delete updatedErrors[`alreadyWorkerError_${indexToRemove}`];
        delete updatedErrors[`alreadyInvitedError_${indexToRemove}`];

        const reindexedErrors = Object.keys(updatedErrors).reduce(
          (acc, key) => {
            const match = key.match(
              /^(firstNameError|lastNameError|emailError|conserveTeamError|alreadyWorkerError|alreadyInvitedError)_(\d+)$/
            );
            if (match) {
              const currentIndex = parseInt(match[2], 10);
              if (currentIndex > indexToRemove) {
                const newIndex = currentIndex - 1;
                const newKey = `${match[1]}_${newIndex}`;
                acc[newKey] = updatedErrors[key];
              } else if (currentIndex !== indexToRemove) {
                acc[key] = updatedErrors[key];
              }
            } else {
              acc[key] = updatedErrors[key];
            }
            return acc;
          },
          {}
        );
        return reindexedErrors;
      });

      return {
        ...prevState,
        workersInviteData: updatedWorkersInviteData,
      };
    });
  };

  const formHandleData = (e, index, name) => {
    setAddWorkerData((prevState) => {
      const updatedWorkersInviteData = [...prevState.workersInviteData];
      if (name == "first_name") {
        updatedWorkersInviteData[index] = {
          ...updatedWorkersInviteData[index],
          first_name: e.target.value,
        };
      } else {
        updatedWorkersInviteData[index] = {
          ...updatedWorkersInviteData[index],
          last_name: e.target.value,
        };
      }

      return {
        ...prevState,
        workersInviteData: updatedWorkersInviteData,
      };
    });
  };

  const HandleChange2 = (e) => {
    setSearch2(e.trim());
    
    if (e !== "" && e?.length > 1) {
      dispatch(
        GetAllIndividualListForWorkerInvites({
          search: e.trim(),
          provider_fa_id: providerFunctionAssignmentId || loginUserData?.function_assignment_id,
          provider_org_id: complianceData.provider_org_id || loginUserData?.organisation_id,
        })
      ).then((response) => {
        if (response.success) {
          const FilterData = response?.data?.map((item) => {
            return {
              label: `${item.first_name}` + "-" + item.email,
              email: item.email,
              value: item.email,
              first_name: item.first_name,
              individual_id: item.individual_id,
              last_name: item.last_name,
              user_id: item.user_id,
              is_conserve_team: item.is_conserve_team,
              worker_id: item.worker_id,
              invite_id: item?.invite_id,
            };
          });
          setSearchOptions(FilterData);
        }
      });
    } else {
      setSearchOptions([]);
    }
  };

  const inputchangehandler2 = useCallback(debounce(HandleChange2), []);

  // Custom option for the input value
  const customOption = { value: search2, label: search2 };
  // Check if the inputValue exists in options, if not, add it
  const updatedOptions = searchOptions?.find(
    (option) => option.value === search2
  )
    ? searchOptions
    : search2 ? [...searchOptions, customOption] : searchOptions;

  const handleSelectChange = (selectedOption, index) => {
    if (selectedOption?.is_conserve_team) {
      setErrorValidation((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        updatedErrors[`conserveTeamError_${index}`] =
          "Conserve team members cannot be added";
        return updatedErrors;
      });
    } else {
      setErrorValidation((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        updatedErrors[`conserveTeamError_${index}`] = "";
        return updatedErrors;
      });
    }

    if (selectedOption?.worker_id) {
      setErrorValidation((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        updatedErrors[`alreadyWorkerError_${index}`] =
          "This worker is already associated with this provider. Please select a different worker.";
        return updatedErrors;
      });
    } else {
      setErrorValidation((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        updatedErrors[`alreadyWorkerError_${index}`] = "";
        return updatedErrors;
      });
    }

    if (selectedOption?.invite_id) {
      setErrorValidation((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        updatedErrors[`alreadyInvitedError_${index}`] =
          "This worker is already invited with this provider. Please select a different worker.";
        return updatedErrors;
      });
    } else {
      setErrorValidation((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        updatedErrors[`alreadyInvitedError_${index}`] = "";
        return updatedErrors;
      });
    }

    let emailAlreadyExist = false;
    setAddWorkerData((prevValue) => {
      const emailToValidate = selectedOption?.label || selectedOption?.email;
      const actualEmail = emailToValidate ? emailToValidate?.split("-")[1]?.trim() || emailToValidate : "";

      const emailMatch = prevValue?.workersInviteData?.some(
        (ele) => ele?.email === actualEmail
      );
      if (emailMatch) {
        setCheckError(false);
        setErrorValidation((prevErrors) => {
          const updatedErrors = { ...prevErrors };
          updatedErrors[`emailError_${index}`] =
            "This email address has already been entered.";
          emailAlreadyExist = true;
          return updatedErrors;
        });
        return prevValue;
      }

      function isEmail(value) {
        if (value !== undefined && value !== "") {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return emailRegex.test(value);
        }
        return false;
      }

      if (emailToValidate && !isEmail(selectedOption?.email || actualEmail)) {
        setErrorValidation((prevErrors) => {
          const updatedErrors = { ...prevErrors };
          updatedErrors[`emailError_${index}`] =
            "Please insert a valid email address";
          emailAlreadyExist = true;
          return updatedErrors;
        });
        return prevValue;
      }

      const updatedWorkersInviteData = prevValue.workersInviteData.map(
        (item, i) => {
          if (i === index) {
            return {
              ...item,
              ...selectedOption,
              email:
                selectedOption == null
                  ? ""
                  : selectedOption.value !== undefined
                    ? selectedOption.value
                    : selectedOption.email,
            };
          }
          return item;
        }
      );

      return {
        ...prevValue,
        workersInviteData: updatedWorkersInviteData,
      };
    });

    if (!emailAlreadyExist) {
      setErrorValidation((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        updatedErrors[`emailError_${index}`] = "";
        return updatedErrors;
      });
    }
  };

  const handleOpen = (value) => {
    setOpen(open === value ? 0 : value);
  };

  function Icon({ id, open }) {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.68296 1.97217V18.7722M1.28296 10.3722H18.083"
          stroke="#5786CC"
          stroke-width="2.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }

  useEffect(() => {
    if (paymentData?.provider_type_fee == "assignment") {
      setUseSavedCard(true);
      setSavedCard(paymentData?.cardDetails[0]);
      if (paymentData?.cardDetails[0]) {
        const checkCardExpiry = paymentData?.cardDetails[0];
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1; // getMonth() returns 0-based month
        const currentYear = currentDate.getFullYear();

        if (
          checkCardExpiry.exp_year < currentYear ||
          (checkCardExpiry.exp_year === currentYear && checkCardExpiry.exp_month < currentMonth)
        ) {
          setCardExpiredOrNot(true);

        }
        else {
          setCardExpiredOrNot(false);

        }
      }
    }    
    if(paymentData?.subscription_id){ // for check subscription 
      setUseSavedCard(true);
      setSavedCard(paymentData?.cardDetails[0]);
      if (paymentData?.cardDetails[0]) {
        const checkCardExpiry = paymentData?.cardDetails[0];
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1; // getMonth() returns 0-based month
        const currentYear = currentDate.getFullYear();

        if (
          checkCardExpiry.exp_year < currentYear ||
          (checkCardExpiry.exp_year === currentYear && checkCardExpiry.exp_month < currentMonth)
        ) {
          setCardExpiredOrNot(true);

        }
        else {
          setCardExpiredOrNot(false);

        }
      }
    }

  }, [paymentData]);
  const handleDeletePDF = (event, field, index) => {
    let newValue;
    if (field == "doc") {
      newValue = event[0];
      setComplianceData((prevalue) => {
        return {
          ...prevalue,
          ["doc" + index]: "",
        };
      });
    }
  };

  // Handle form
  const handleForm = (event, field, index, custom_field, customIndex) => {
    let newValue;
    if (field == "allow_expiry") {
      newValue = event;
    } else if (field == "doc") {
      newValue = event[0];
      setComplianceData((prevalue) => {
        return {
          ...prevalue,
          ["doc" + index]: newValue,
        };
      });
      return;
    } else {
      newValue = event.target.value;
    }
    setComplianceData((prevValue) => {
      // Create a new array with the updated field
      const updatedDocsData = prevValue.docsData.map((item, idx) => {
        if (idx === index) {
          // Return a new object with updated field
          if (field == "doctype_fields_data") {
            return {
              ...item,
              doctype_fields_data: item.doctype_fields_data.map(
                (fieldItem, fieldIdx) => {
                  if (fieldIdx === customIndex) {
                    // Update the specific field within doctype_fields_data
                    return {
                      ...fieldItem,
                      [custom_field]: newValue,
                    };
                  }
                  // Return unchanged fieldItem for all other indices
                  return fieldItem;
                }
              ),
            };
          } else {
            return {
              ...item,
              [field]: newValue,
            };
          }
        }
        // Return unchanged item for all other indices
        return item;
      });

      // Return the updated state
      return {
        ...prevValue,
        docsData: updatedDocsData,
      };
    });
  };

  // Min Date
  const minDate = dayjs(new Date())
    .subtract(dateGap, "day")
    .startOf("day")
    .toDate();

  const combinedProvCheckDoc = docData?.flatMap((item) => item.inviteProviComp);
  const combinedWorkerCheckDoc = workerDocData?.flatMap(
    (item) => item.inviteProviComp
  );

  const submitWorkersAndFinish = async () => {
    const workersWithEmail = addWorkerData?.workersInviteData?.filter(
      (item) => item.email && item.email.trim() !== ""
    );

    if (!workersWithEmail || workersWithEmail.length === 0) {
      props.onDialogClose();
      return;
    }

    let checkValidation = workersWithEmail?.every(
      (item) => item.first_name && item.last_name && item.email
    );

    if (workersWithEmail.length > 0 && !checkValidation) {
      setCheckError(true);
      return;
    }

    const hasErrors = Object.values(errorValidation).some((error) => error !== "");
    if (hasErrors) {
      notify.show("Please fix all validation errors before proceeding", "error", 3000);
      return;
    }

    setIsProcessing(true);

    const updateObject = {
      ...addWorkerData,
      workersInviteData: workersWithEmail,
      provider_fa_id:
        providerFunctionAssignmentId ||
        loginUserData?.function_assignment_id ||
        complianceData?.provider_fa_id,
      trading_name: complianceData.provider_trading_name || loginUserData?.trading_name,
      provider_org_id:
        complianceData.provider_org_id ||
        props?.ProviderExistingUser?.provider_org_id ||
        loginUserData?.organisation_id,
      client_org_id:
        complianceData.client_org_id ||
        props?.ProviderExistingUser?.client_org_id ||
        ProviderContactData?.provInviteClient?.org_data?.organisation_id,
      workerClientsIds: [
        complianceData.client_org_id ||
          props?.ProviderExistingUser?.client_org_id ||
          ProviderContactData?.provInviteClient?.org_data?.organisation_id,
      ],
    };

    try {
      const response = await dispatch(RegisterWorker(updateObject));
      if (response && response.success) {
        notify.show("Workers registered successfully!", "success", 3000);
        setIsProcessing(false);
        props.onDialogClose();
      } else {
        notify.show(response?.message || "Failed to register workers", "error", 3000);
        setIsProcessing(false);
      }
    } catch (error) {
      console.error("Error registering workers:", error);
      notify.show("An error occurred while registering workers", "error", 3000);
      setIsProcessing(false);
    }
  };

  const onNext = async (step) => {
    if (ProviderContactData?.is_client_pay_licence) {
      if (step == 1) {
        await submitWorkersAndFinish();
        return;
      }

      const allFieldsNonEmpty = complianceData.docsData.map((doc) => {
        let allNonEmpty = true;

        Object.keys(doc).forEach((key) => {
          if (typeof doc[key] === "string" && doc[key] === "") {
            allNonEmpty = false;
          } else if (Array.isArray(doc[key])) {
            doc[key].forEach((item) => {
              Object.keys(item).forEach((innerKey) => {
                if (item[innerKey] === "") {
                  allNonEmpty = false;
                }
              });
            });
          }
        });

        return allNonEmpty;
      });
      const hasNonEmptyValues = (data) => {
        return Object.keys(data).some(
          (key) =>
            key !== "client_org_id" &&
            key !== "provider_org_id" &&
            key !== "docsData" &&
            data[key] !== ""
        );
      };

      const result = hasNonEmptyValues(complianceData);
      const checkValue = allFieldsNonEmpty.some((value) => value === false)
        ? false
        : true;
      if (combinedProvCheckDoc.length == 0) {
        onChange(step + 1);
      } else {
        if (checkValue && result) {
          //apply loader 
          setIsProcessing(true);
          dispatch(AddProviderDocsAndSubmit(complianceData, token))
            .then(
              (response) => {
                if (response.success) {
                  onChange(step + 1);
                }
              }
            ).finally(() => {
              setIsProcessing(false);
            })
          setCheckError(false);
        } else {
          setCheckError(true);
        }
      }
    } else {
      if (step == 0) {
        // If payment has already been completed (or marked as bypassed/zero-amount)
        // then simply advance to the Compliance checklist instead of re-calling the
        // registration API. This fixes the issue where Continue was re-triggering
        // RegisterExistingProviderForClient even after showing the "Payment successful" panel.
        if (!checkPayment) {
          onChange(step + 1);
          return;
        }
        if (useSavedCard && checkPayment) {
          let tradingName = {
            provider_trading_name: loginUserData?.trading_name,
            abn_nzbn: loginUserData?.abn_nzbn,
          };

          let payload = {
            ...props?.ProviderExistingUser,
            provider_trading_name: loginUserData?.trading_name,
            abn_nzbn: loginUserData?.abn_nzbn,
            trading_name: props?.ProviderExistingUser?.client_contact_data?.first_name + " " + props?.ProviderExistingUser?.client_contact_data?.last_name,
            is_client_pay_licence: ProviderContactData?.is_client_pay_licence,
            isProviderExist: true,
            no_of_emp: parseInt(additionalWorkers) || 0,
            user_id: props?.ProviderExistingUser?.client_contact_data?.user_id || loginUserData?.userName?.user_id || loginUserData?.userName?.user_data?.user_id,
            subscription_duration: subscriptionDuration,
            payment_info: {
              provider_type_fee: paymentData?.provider_type_fee,
              stripe_price_object_id: paymentData?.stripe_price_object_id,
              amount: paymentData?.amount,
              worker_fees: {
                worker_count: parseInt(additionalWorkers) || 0,
                chargeable_workers: parseInt(additionalWorkers) || 0,
                free_workers: 0,
                available_free_seats: 0,
                worker_unit_price: paymentData?.per_worker_fee || 0,
                total_worker_fee: paymentData?.worker_amount || 0,
                provider_type_name: paymentData?.provider_type_name || ""
              }
            }
          };
          if (paymentData?.provider_type_id || paymentData?.amount) {
            setIsProcessing(true);
            dispatch(RegisterExistingProviderForClient(payload)).then(
              (resp) => {
                if (resp.success) {
                  console.log("RegisterExistingProviderForClient", resp?.data)
                  setComplianceData({
                    client_org_id: resp?.data?.client_org_id,
                    provider_org_id: resp?.data?.provider_org_id,
                    docsData: [],
                    provider_trading_name: resp?.data?.provider_trading_name,
                    abn_nzbn: resp?.data?.abn_nzbn,
                  });
                  checkListData(
                    resp?.data?.client_org_id,
                    resp?.data?.provider_org_id,
                    resp?.data?.sub_invoice_id
                  );
                  // Update seat count to include newly purchased workers
                  setSeatCount(prevCount => prevCount + parseInt(additionalWorkers || 0));
                  setIsProcessing(false);
                  // setStep(1);
                  setCheckPayment(false);
                } else {
                  notify.show(resp?.message || "Failed to accept client invitation", "error", 4000);
                  setIsProcessing(false);
                }
              }
            ).finally(() => {
              setIsProcessing(false);
            })
          }
        }
        else if (checkPayment && !useSavedCard) {
          // If the total payable is zero, bypass Stripe tokenization but keep Step 0 UI visible
          const computedTotal = (paymentData?.amount !== undefined && paymentData?.amount !== null)
            ? Number(paymentData?.amount)
            : Number(paymentData?.licence_fee || 0) + Number(paymentData?.worker_amount || 0);
          if (!isNaN(computedTotal) && computedTotal === 0) {
            try {
              setIsProcessing(true);
              let payload = {
                ...props?.ProviderExistingUser,
                provider_trading_name: loginUserData?.trading_name,
                abn_nzbn: loginUserData?.abn_nzbn,
                trading_name:
                  props?.ProviderExistingUser?.client_contact_data?.first_name +
                  " " +
                  props?.ProviderExistingUser?.client_contact_data?.last_name,
                is_client_pay_licence: ProviderContactData?.is_client_pay_licence,
                isProviderExist: true,
                no_of_emp: parseInt(additionalWorkers) || 0,
                user_id:
                  props?.ProviderExistingUser?.client_contact_data?.user_id ||
                  loginUserData?.userName?.user_id ||
                  loginUserData?.userName?.user_data?.user_id,
                subscription_duration: subscriptionDuration,
                payment_info: {
                  provider_type_fee: paymentData?.provider_type_fee,
                  stripe_price_object_id: paymentData?.stripe_price_object_id,
                  amount: 0,
                  cardToken: null,
                  worker_fees: {
                    worker_count: parseInt(additionalWorkers) || 0,
                    chargeable_workers: parseInt(additionalWorkers) || 0,
                    free_workers: 0,
                    available_free_seats: 0,
                    worker_unit_price: paymentData?.per_worker_fee || 0,
                    total_worker_fee: paymentData?.worker_amount || 0,
                    provider_type_name: paymentData?.provider_type_name || "",
                  },
                },
              };

              if (paymentData?.provider_type_id || computedTotal === 0) {
                dispatch(RegisterExistingProviderForClient(payload))
                  .then((resp) => {
                    if (resp?.success) {
                      setComplianceData({
                        client_org_id: resp?.data?.client_org_id,
                        provider_org_id: resp?.data?.provider_org_id,
                        docsData: [],
                        provider_trading_name: resp?.data?.provider_trading_name,
                        abn_nzbn: resp?.data?.abn_nzbn,
                      });
                      checkListData(
                        resp?.data?.client_org_id,
                        resp?.data?.provider_org_id,
                        resp?.data?.sub_invoice_id
                      );
                      setSeatCount((prev) => prev + parseInt(additionalWorkers || 0));
                      setCheckPayment(false);
                    } else {
                      notify.show(resp?.message || "Failed to accept client invitation", "error", 4000);
                    }
                  })
                  .finally(() => setIsProcessing(false));
              } else {
                notify.show("Provider subscription details are required", "error", 4000);
                setIsProcessing(false);
              }
            } catch (e) {
              notify.show(e?.message || "An error occurred", "error", 4000);
              setIsProcessing(false);
            }
            return;
          }

          setIsProcessing(true);
          if (!stripe || !elements) {
            return;
          }

          const cardElement = elements.getElement(CardElement);
          const { error, token } = await stripe.createToken(cardElement);

          if (error) {
            setError(error.message);
            console.error(error);
            setIsProcessing(false);
          } else {
            let tradingName = {
              provider_trading_name: loginUserData?.trading_name,
              abn_nzbn: loginUserData?.abn_nzbn,
            };
            let payload = {
              ...props?.ProviderExistingUser,
              provider_trading_name: loginUserData?.trading_name,
              abn_nzbn: loginUserData?.abn_nzbn,
              trading_name: props?.ProviderExistingUser?.client_contact_data?.first_name + " " + props?.ProviderExistingUser?.client_contact_data?.last_name,
              is_client_pay_licence: ProviderContactData?.is_client_pay_licence,
              isProviderExist: true,
              no_of_emp: parseInt(additionalWorkers) || 0,
              user_id: props?.ProviderExistingUser?.client_contact_data?.user_id || loginUserData?.userName?.user_id || loginUserData?.userName?.user_data?.user_id,
              subscription_duration: subscriptionDuration,
              payment_info: {
                provider_type_fee: paymentData?.provider_type_fee,
                stripe_price_object_id: paymentData?.stripe_price_object_id,
                amount: paymentData?.amount,
                cardToken: token.id,
                saveCard,
                worker_fees: {
                  worker_count: parseInt(additionalWorkers) || 0,
                  chargeable_workers: parseInt(additionalWorkers) || 0,
                  free_workers: 0,
                  available_free_seats: 0,
                  worker_unit_price: paymentData?.per_worker_fee || 0,
                  total_worker_fee: paymentData?.worker_amount || 0,
                  provider_type_name: paymentData?.provider_type_name || ""
                }
              }
            };
            if (paymentData?.provider_type_id || paymentData?.amount) {
              dispatch(RegisterExistingProviderForClient(payload))
                .then(
                  (resp) => {
                    if (resp.success) {
                      setComplianceData({
                        client_org_id: resp?.data?.client_org_id,
                        provider_org_id: resp?.data?.provider_org_id,
                        docsData: [],
                        provider_trading_name: resp?.data?.provider_trading_name,
                        abn_nzbn: resp?.data?.abn_nzbn,
                      });
                      checkListData(
                        resp?.data?.client_org_id,
                        resp?.data?.provider_org_id,
                        resp?.data?.sub_invoice_id
                      );
                      // Update seat count to include newly purchased workers
                      setSeatCount(prevCount => prevCount + parseInt(additionalWorkers || 0));
                      setIsProcessing(false);
                      // setStep(1);
                      setCheckPayment(false);
                    } else {
                      notify.show(resp?.message || "Failed to accept client invitation", "error", 4000);
                      setIsProcessing(false);
                    }
                  }
                ).finally(() => {
                  setIsProcessing(false);
                })
            }
          }
        }
        else {
          // Zero-amount or payment-bypassed flow: still register the existing provider
          // to generate sub_invoice_id and link compliance. Do NOT skip API.
          try {
            setIsProcessing(true);
            let payload = {
              ...props?.ProviderExistingUser,
              provider_trading_name: loginUserData?.trading_name,
              abn_nzbn: loginUserData?.abn_nzbn,
              trading_name:
                props?.ProviderExistingUser?.client_contact_data?.first_name +
                " " +
                props?.ProviderExistingUser?.client_contact_data?.last_name,
              is_client_pay_licence: ProviderContactData?.is_client_pay_licence,
              isProviderExist: true,
              no_of_emp: parseInt(additionalWorkers) || 0,
              user_id:
                props?.ProviderExistingUser?.client_contact_data?.user_id ||
                loginUserData?.userName?.user_id ||
                loginUserData?.userName?.user_data?.user_id,
              subscription_duration: subscriptionDuration,
              payment_info: {
                provider_type_fee: paymentData?.provider_type_fee,
                stripe_price_object_id: paymentData?.stripe_price_object_id,
                amount: Number(paymentData?.amount || 0),
                cardToken: null, // explicitly null for $0
                saveCard,
                worker_fees: {
                  worker_count: parseInt(additionalWorkers) || 0,
                  chargeable_workers: parseInt(additionalWorkers) || 0,
                  free_workers: 0,
                  available_free_seats: 0,
                  worker_unit_price: paymentData?.per_worker_fee || 0,
                  total_worker_fee: paymentData?.worker_amount || 0,
                  provider_type_name: paymentData?.provider_type_name || "",
                },
              },
            };

            if (paymentData?.provider_type_id || Number(paymentData?.amount || 0) === 0) {
              dispatch(RegisterExistingProviderForClient(payload))
                .then((resp) => {
                  if (resp?.success) {
                    setComplianceData({
                      client_org_id: resp?.data?.client_org_id,
                      provider_org_id: resp?.data?.provider_org_id,
                      docsData: [],
                      provider_trading_name: resp?.data?.provider_trading_name,
                      abn_nzbn: resp?.data?.abn_nzbn,
                    });
                    checkListData(
                      resp?.data?.client_org_id,
                      resp?.data?.provider_org_id,
                      resp?.data?.sub_invoice_id
                    );
                    // Update seat count to include newly purchased workers (zero by default)
                    setSeatCount((prev) => prev + parseInt(additionalWorkers || 0));
                    try { localStorage.setItem('countpaymentpage', 'zeroAmountExistingSuccess'); } catch (e) {}
                    setCheckPayment(false);
                    // After successful registration and checklist fetch, advance
                    // setStep(1); // optional if step advance is handled elsewhere
                  }
                })
                .finally(() => {
                  setIsProcessing(false);
                });
            } else {
              setIsProcessing(false);
            }
          } catch (e) {
            setIsProcessing(false);
          }
        }
      }
      if (step == 2) {
        await submitWorkersAndFinish();
        return;
      }
      if (step == 1) {
        // Skip document validation - allow proceeding without uploading compliance documents
        if (combinedProvCheckDoc.length == 0) {
          onChange(step + 1);
        } else {
          // Filter out documents that don't have files uploaded
          const filteredDocsData = complianceData.docsData.filter((doc, idx) => {
            const hasFile = complianceData["doc" + idx] && complianceData["doc" + idx] !== "";
            return hasFile;
          });

          // Create payload with only documents that have files
          const newPayload = {
            ...complianceData,
            docsData: filteredDocsData
          };

          // Process expiry dates for filtered documents
          newPayload?.docsData?.forEach(doc => {
            if (doc.hasOwnProperty('allow_expiry') && doc.allow_expiry) {
              doc.expiry_date = doc.allow_expiry;
            }
          });

          //apply loader
          setIsProcessing(true);
          if(filteredDocsData.length > 0){
            dispatch(AddProviderDocsAndSubmit(newPayload, token))
              .then(
                (response) => {
                  if (response.success) {
                    onChange(step + 1);
                  }
                }
              ).finally(() => {
                setIsProcessing(false);
              })
            setCheckError(false);
          }else{
            setIsProcessing(false);
            onChange(step + 1);
          }
          setIsProcessing(false);
        }
      }
    }
  };

  const { tempEngagementDoc, tempMsaDoc, ...updatedData } =
    ProviderRegisterFinalData;

  const downloadInvoice = () => {
    // invoiceData.xero_invoice_pdf
    if (invoiceData && invoiceData.xero_invoice_pdf) {
      const link = document.createElement("a");
      link.href = invoiceData.xero_invoice_pdf;
      link.download = "invoice.pdf"; // Set the file name
      link.target = "_blank"; // Open in new tab for security if on another domain
      link.click();
    } else {
      console.error("No PDF URL found in invoice data");
    }
  };

  useEffect(() => {
    if (ProviderContactData?.is_client_pay_licence) {
      let tradingName = {
        provider_trading_name: loginUserData?.trading_name,
        abn_nzbn: loginUserData?.abn_nzbn,
      };
      let payload = {
        ...props?.ProviderExistingUser,
        is_client_pay_licence: ProviderContactData?.is_client_pay_licence,
        isProviderExist: true,
        user_id: loginUserData?.userName?.user_id || loginUserData?.userName?.user_data?.user_id,
        provider_trading_name: loginUserData?.trading_name || props?.ProviderExistingUser?.provider_trading_name,
        abn_nzbn: loginUserData?.abn_nzbn || props?.ProviderExistingUser?.abn_nzbn,
        trading_name:
          props?.ProviderExistingUser?.trading_name ||
          ProviderContactData?.provInviteClient?.org_data?.trading_name ||
          "",
        client_org_id:
          props?.ProviderExistingUser?.client_org_id ||
          ProviderContactData?.provInviteClient?.org_data?.organisation_id,
        client_fa_id:
          props?.ProviderExistingUser?.client_fa_id || ProviderContactData?.client_fa_id,
        provider_type_id:
          props?.ProviderExistingUser?.provider_type_id || ProviderContactData?.provider_type_id,
        invite_provider_id:
          props?.ProviderExistingUser?.invite_provider_id || ProviderContactData?.invite_provider_id,
      };
      if (true) {
        dispatch(RegisterExistingProviderForClient(payload)).then((resp) => {
          if (resp.success) {
            setIsProcessing(false);
            setAgree(true);
            setComplianceData({
              client_org_id: resp?.data?.client_org_id,
              provider_org_id: resp?.data?.provider_org_id,
              docsData: [],
              provider_trading_name: resp?.data?.provider_trading_name,
              abn_nzbn: resp?.data?.abn_nzbn,
            });

            checkListData(
              resp?.data?.client_org_id,
              resp?.data?.provider_org_id,
              resp?.data?.sub_invoice_id
            );

            // setStep(1);
            setCheckPayment(false);
          } else {
            notify.show(resp?.message || "Failed to accept client invitation", "error", 4000);
            setIsProcessing(false);
          }
        });
      }
    } else {
      // Change this payload Check comments old payload data
      let payload = {
        registrationType: "inviteByClient",
        // provider_type_id:  props?.formData?.provider_regist_data?.provider_type_id || "",        
        // invite_provider_id: invite_provider_id,
        // isProviderExist: false,
        // provider_org_id: "",
        provider_type_id: props?.ProviderExistingUser?.provider_type_id || "",
        invite_provider_id: props?.ProviderExistingUser?.invite_provider_id,
        isProviderExist: true,
        provider_org_id: props?.ProviderExistingUser?.provider_org_id,
        no_of_emp: parseInt(additionalWorkers) || 0,
      };
      dispatch(ProviderRegisterPaymentInfo(payload)).then((response) => {
        if (response) {
          if (response?.data?.isSubscExpired) {
            // close that dialog payment and show expired message dialog here 
            setProviderSubExipred(true)
          }
          else {
            console.log('ProviderRegisterPaymentInfo response:', response?.data);
            console.log('Worker fees data:', response?.data?.worker_fees);
            setPaymentData(response?.data);
          }

        }
      });
    }
  }, []);

  // Refetch payment info when worker count changes (debounced)
  useEffect(() => {
    if (!ProviderContactData?.is_client_pay_licence && additionalWorkers > 0 && paymentData) {
      // Debounce API call - wait 500ms after user stops typing
      const timeoutId = setTimeout(() => {
        let payload = {
          registrationType: "inviteByClient",
          provider_type_id: props?.ProviderExistingUser?.provider_type_id || "",
          invite_provider_id: props?.ProviderExistingUser?.invite_provider_id,
          isProviderExist: true,
          provider_org_id: props?.ProviderExistingUser?.provider_org_id,
          no_of_emp: parseInt(additionalWorkers) || 0,
        };
        
        dispatch(ProviderRegisterPaymentInfo(payload)).then((response) => {
          if (response && response.success) {
            console.log('Updated ProviderRegisterPaymentInfo with workers:', response?.data);
            console.log('Updated worker fees data:', response?.data?.worker_fees);
            setPaymentData(response?.data);
          }
        });
      }, 500);

      // Cleanup function to cancel the timeout if additionalWorkers changes again
      return () => clearTimeout(timeoutId);
    }
  }, [additionalWorkers]);

  // useEffect(() => {
  //   let payload = {
  //       props?.formData?.provider_regist_data?.provider_type_id || "",
  //     registrationType: "inviteByClient",
  //     provider_type_id:
  //     invite_provider_id: props?.ProviderExistingUser?.invite_provider_id,
  //     isProviderExist: true,
  //     provider_org_id: loginUserData?.organisation_id,
  //   };
  //   dispatch(ProviderRegisterPaymentInfo(payload)).then((response) => {
  //     if (response) {
  //       setPaymentData(response?.data);
  //     }
  //   });
  // }, []);

  const checkListData = (client_org_id, provider_org_id, sub_invoice_id) => {
    setComplianceData((prevValue) => {
      return {
        ...prevValue,
        docsData: [],
      };
    });
    dispatch(
      GetProviderChecklistByClient({
        client_org_id: client_org_id,
        provider_org_id: provider_org_id,
        sub_invoice_id: sub_invoice_id,
      })
    ).then((response) => {
      console.log("RESPONSE", response?.data)
      if (response.success) {
        setInvoiceData(response?.data?.invoice);
        
        // Set provider function assignment ID and seat count
        if (response?.data?.provider_fa_id) {
          setProviderFunctionAssignmentId(response.data.provider_fa_id);
        }
        
        if (response?.data?.seatCount !== undefined) {
          setSeatCount(Number(response.data.seatCount));
          setInvitedWorkersCount(Number(response.data.invitedWorkers || 0));
        }
        
        SetDocData(
          response?.data?.inviteProvComp?.filter(
            (item) => item.check_comp_assigned_to == 1 && item
          )
        );
        SetworkerDocData(
          response?.data?.inviteProvComp?.filter(
            (item) => item.check_comp_assigned_to == 0 && item
          )
        );
        response?.data?.inviteProvComp?.flatMap(
          (doc, index) =>
            doc?.check_comp_assigned_to == 1 &&
            doc?.inviteProviComp?.map((item, innerIndex) => {
              const newObject = {};
              newObject["checklist_doc_id"] = item.checklist_doc_id;
              newObject["is_other_doc"] = item.is_other_doc;
              newObject["doc_name"] = "";
              for (const [key, value] of Object.entries(item?.document_type)) {
                if (key == "document_type_id") {
                  newObject["document_type_id"] = value;
                }
                if (key == "custom_fields" && !item.is_other_doc) {
                  newObject["doctype_fields_data"] = value?.map((key) => ({
                    [key]: "",
                  }));
                }
                if (value === true) {
                  newObject[key] = "";
                }
              }
              setComplianceData((prevValue) => {
                return {
                  ...prevValue,
                  [`doc${index + innerIndex}`]: "",
                  // [`doc${index + innerIndex}`]: "",
                  docsData: [...prevValue.docsData, newObject],
                };
              });
            })
        );
      }
    });
  };
  const closeProviderExpiredDialog = () => {
    props.onDialogClose();
    setProviderSubExipred(false)
    return;
  }
  return (
    <React.Fragment>
      <div className="px-6">
        <Steps current={step}>
          {ProviderContactData?.is_client_pay_licence == false && (
            <Steps.Item title="Payment" />
          )}
          <Steps.Item title="Compliance checklist" />
          <Steps.Item title="Workers assignment" />
        </Steps>
      </div>

      <form>
        <div className="mt-6 add-client-form px-6">
          {ProviderContactData?.is_client_pay_licence == false && step === 0 ? (
            <React.Fragment>
              {checkPayment && (
                <div className="pl-6 pr-6">
                  <h5 className="text-blue-800 font-semibold text-2xl mb-2">
                    Payment options
                  </h5>
                  <p className="text-gray-700 mb-3">
                    This {subscriptionDuration === "1_week" ? "weekly" : subscriptionDuration === "1_month" ? "monthly" : "annual"} payment covers the cost of connecting you with the client, ensuring ongoing access and seamless collaboration.
                  </p>
                  <div>
                    <div className="w-full">
                      <form>
                        {ProviderContactData?.is_client_pay_licence === false && (
                          <Card className="p-7 border border-gray-200 rounded-xl mt-7">
                            
                            <div className="items-start">
                              <label className="block text-gray-700 mb-2 text-xs font-medium">
                                How many workers would you like to register for this client?*
                              </label>

                              <input
                                className="input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                type="number"
                                placeholder="Enter number of workers here"
                                value={additionalWorkers}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setAdditionalWorkers(value);
                                  setWorkerError("");
                                  
                                  // Update payment data with worker count
                                  // First licence gets 2 free worker seats, assignments get 0 free seats
                                  const workerCount = parseInt(value) || 0;
                                  const availableFreeSeats = paymentData?.worker_fees?.available_free_seats !== undefined
                                    ? paymentData.worker_fees.available_free_seats
                                    : (paymentData?.provider_type_fee === 'licence' ? 2 : 0);
                                  const chargeableWorkers = Math.max(0, workerCount - availableFreeSeats);
                                  const freeWorkers = Math.min(availableFreeSeats, workerCount);
                                  const perWorkerFee = paymentData?.per_worker_fee || 0;
                                  const calculatedWorkerAmount = chargeableWorkers * perWorkerFee;
                                  const newTotalAmount = (paymentData?.licence_fee || 0) + calculatedWorkerAmount;
                                  
                                  console.log('Worker calculation (Existing Provider):', {
                                    workerCount,
                                    availableFreeSeats,
                                    freeWorkers,
                                    chargeableWorkers,
                                    perWorkerFee,
                                    calculatedWorkerAmount,
                                    licence_fee: paymentData?.licence_fee,
                                    newTotalAmount,
                                    paymentData: paymentData
                                  });
                                  
                                  setPaymentData(prev => ({
                                    ...prev,
                                    worker_fees: {
                                      ...prev?.worker_fees,
                                      worker_count: workerCount,
                                      available_free_seats: availableFreeSeats,
                                      free_workers: freeWorkers,
                                      chargeable_workers: chargeableWorkers
                                    },
                                    worker_amount: calculatedWorkerAmount,
                                    amount: newTotalAmount
                                  }));
                                }}
                                maxLength="14"
                                minLength="11"
                                onKeyDown={(e) => {
                                  if (e.key === '-' || e.key === '+' || e.key === 'e' || e.key === 'E' || e.key === '.') {
                                    e.preventDefault();
                                  }
                                }}
                              />

                            {workerError && (
                              <p className="text-xs text-red-600 mt-1">{workerError}</p>
                            )}
                            </div>
                          </Card>
                        )}
                        <Card className="p-7 border border-gray-200 rounded-xl mt-7">
                          <>
                            <h4 className="font-bold text-gray-700 text-base mb-1">
                            License Period
                            </h4>
                            <div className="mb-3">
                              <label htmlFor="subscriptionDuration" className="block text-gray-700 mb-2 text-xs font-medium">
                                Select duration
                              </label>
                              <select
                                id="subscriptionDuration"
                                value={subscriptionDuration}
                                onChange={(e) => setSubscriptionDuration(e.target.value)}
                                className="h-10 w-full border border-gray-300 rounded-lg px-3 focus:outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-500"
                              >
                                <option value="1_week">1 week</option>
                                <option value="1_month">1 month</option>
                                <option value="1_year">1 year</option>
                              </select>
                            </div>
                            <p className="text-gray-700">
                            {moment(new Date()).format("DD/MM/YYYY")} -{" "}
                            {moment(new Date())
                              .add(
                                subscriptionDuration === "1_week"
                                  ? 1
                                  : subscriptionDuration === "1_month"
                                  ? 1
                                  : 1,
                                subscriptionDuration === "1_week"
                                  ? "week"
                                  : subscriptionDuration === "1_month"
                                  ? "month"
                                  : "year"
                              )
                              .format("DD/MM/YYYY")}
                            </p>
                          </>
                          <h4 className="font-bold text-gray-700 text-base mb-1">
                            Total Fee
                          </h4>
                          <p className="text-gray-700 mb-7">
                            {paymentData?.amount
                              ? `$ ${(Number(paymentData?.amount)).toFixed(2)}`
                              : "We couldn't retrieve the fee information. Please try again later."}
                          </p>

                          <h4 className="font-bold text-gray-700 text-sm mb-2">
                            This fee includes
                          </h4>

                          <div className="mb-2 input-shadow border border-gray-300 rounded-lg">
                            <div className="h-10 text-sm w-full py-2 px-3 text-gray-900 flex justify-between items-center border-b border-gray-300">
                              <span className="text-gray-700 text-sm font-semibold font-weight-500">
                                {paymentData?.provider_type_fee === "licence" ? "Base Annual Licence Fee" : "Annual Client Assignment Fee"}
                              </span>
                              <span className="text-gray-700 text-sm font-semibold font-weight-600">$ {(Number(paymentData?.licence_fee || 0)).toFixed(2)}</span>
                            </div>
                            <div className="h-10 text-sm w-full py-2 px-3 text-gray-900 flex justify-between items-center">
                              <span className="text-gray-700 text-sm font-semibold font-weight-500">
                                {paymentData?.worker_fees?.chargeable_workers || 0} Additional Workers
                                {paymentData?.worker_fees?.free_workers > 0 ? ` (${paymentData.worker_fees.free_workers} included free)` : ""}
                              </span>
                              <span className="text-gray-700 text-sm font-semibold font-weight-600">$ {(Number(paymentData?.worker_amount || 0)).toFixed(2)}</span>
                            </div>
                          </div>
                          
                          <h4 className="text-gray-700 text-sm mb-1 italic font-weight-500 font-semibold">
                            You will be prompted to allocate workers on the following screen.
                          </h4>
                          <>
                            
                          </>
                          
                        </Card>
                        {(Number(paymentData?.amount || 0) > 0 ||
                          (Number(paymentData?.licence_fee || 0) + Number(paymentData?.worker_amount || 0)) > 0) && (
                        <Card className="p-7 border border-gray-200 rounded-xl mt-7">
                          <div className="bg-gray-100">
                            <div className="bg-white w-full">
                              {/* Payment Method Header with Info Note aligned right */}
                              <div className="flex items-center justify-between mb-3">
                                <h2 className="text-lg font-semibold">Card Information</h2>
                                <span className="text-gray-500 text-sm font-normal flex items-center gap-2">
                                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33334 8 1.33334C4.3181 1.33334 1.33334 4.3181 1.33334 8C1.33334 11.6819 4.3181 14.6667 8 14.6667Z" stroke="#6B7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M8 10.6667V8" stroke="#6B7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M8 5.33334H8.00667" stroke="#6B7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                  </svg>
                                  Please go to settings to change card details.
                                </span>
                              </div>
                              <form className="space-y-4">
                                {/* Card Number */}
                                <div className="border rounded-lg p-3 focus-within:border-blue-500 transition">
                                  {/* Here set assignment_fee use saved card */}
                                  {useSavedCard && savedCard && (
                                    <>
                                      <div
                                        className={`flex items-center justify-between p-4 border rounded-lg cursor-pointer transition hover:shadow-md ${useSavedCard ? "border-blue-500" : "border-gray-300"
                                          }`}
                                        onClick={() => setUseSavedCard(true)}
                                      >
                                        <label className="flex items-center gap-4 w-full cursor-pointer">
                                          <input
                                            type="radio"
                                            name="paymentMethod"
                                            checked={useSavedCard}
                                            onChange={() => setUseSavedCard(true)}
                                            className="form-radio text-blue-600 cursor-pointer"
                                          />
                                          <div className="flex justify-between items-center w-full text-sm text-gray-800">
                                            <span className="tracking-widest font-mono text-base">
                                              **** **** **** {savedCard.last4}
                                            </span>
                                            <div className="flex items-center gap-4 text-gray-500 text-sm ml-4">
                                              <span className="capitalize">{savedCard.brand}</span>
                                              <span>
                                                {String(savedCard.exp_month).padStart(2, '0')}/{savedCard.exp_year}
                                              </span>
                                            </div>
                                          </div>
                                        </label>
                                      </div>
                                      {cardExpiredOrNot && (
                                        <div className="text-red-500 text-sm mt-1 ">
                                          {"We're sorry, but your credit card has expired and we couldn't process your payment."}
                                        </div>
                                      )}
                                    </>
                                  )}

                                  {!useSavedCard && (
                                    <CardElement
                                      options={{
                                        hidePostalCode: true,
                                        disableAutofill: true, // Prevent autofill suggestions
                                        style: {
                                          base: {
                                            fontSize: "16px",
                                            color: "#333",
                                            "::placeholder": {
                                              color: "#a0aec0",
                                            },
                                          },
                                          invalid: { color: "#e53e3e" },
                                        },
                                      }}
                                    />
                                  )}
                                </div>

                                {/* Checkbox */}
                                <div className="flex items-center gap-2">
                                  <input
                                    type="checkbox"
                                    id="terms"
                                    checked={agree}
                                    onChange={() => setAgree(!agree)}
                                    className="cursor-pointer"
                                  />
                                  <label
                                  htmlFor="terms"
                                  className="text-sm text-gray-600 cursor-pointer"
                                >
                                  I understand and accept that this licensing fee is valid for 12 months
                                </label>
                              </div>

                              

                                {/* Save card checkbox: show only when using a new card */}
                                {!useSavedCard && (
                                  <div className="flex items-start gap-2 mt-2">
                                    <input
                                      type="checkbox"
                                      id="saveCard"
                                      checked={saveCard}
                                      onChange={() => setSaveCard(!saveCard)}
                                      className="mt-1 cursor-pointer"
                                    />
                                    <label htmlFor="saveCard" className="text-sm text-gray-600 cursor-pointer">
                                      Save card for future payments
                                    </label>
                                  </div>
                                )}

                                {/* Submit Button */}

                                {/* Error Message */}
                                {error && (
                                  <p className="text-red-500 text-sm">
                                    {error}
                                  </p>
                                )}
                              </form>
                            </div>
                          </div>
                        </Card>
                        )}
                      </form>
                    </div>
                  </div>
                </div>
              )}

              {!checkPayment && (
                <React.Fragment>
                  <div className="pl-4 pr-4">
                    <div className="mb-5 bg-gray-50 rounded-xl border border-gray-200 p-5">
                      <h3 className="mb-1 text-gray-700 font-bold text-base">
                        Payment successful
                      </h3>
                      <p className="mb-4 text-gray-700">
                        Thank you for your payment. A confirmation of this
                        transaction has been sent to your email.
                      </p>
                      <h3 className="mb-1 text-gray-700 font-bold text-base">
                        Invoice number{" "}
                      </h3>
                      <p className="mb-4 text-gray-700">
                        <p>{invoiceData?.xero_invoice_number}</p>
                      </p>
                      <Button
                        className="flex gap-1  text-blue-700 hover:text-blue-900 focus:text-blue-700"
                        onClick={downloadInvoice}
                      >
                        Download invoice{" "}
                        <svg
                          width="21"
                          height="21"
                          viewBox="0 0 21 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.583 13.2866V14.2866C17.583 15.6868 17.583 16.3868 17.3105 16.9216C17.0708 17.392 16.6884 17.7745 16.218 18.0141C15.6832 18.2866 14.9831 18.2866 13.583 18.2866H6.58301C5.18288 18.2866 4.48281 18.2866 3.94803 18.0141C3.47763 17.7745 3.09517 17.392 2.85549 16.9216C2.58301 16.3868 2.58301 15.6868 2.58301 14.2866V13.2866M14.2497 9.11995L10.083 13.2866M10.083 13.2866L5.91634 9.11995M10.083 13.2866V3.28662"
                            stroke="#5786CC"
                            stroke-width="1.66667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </Button>
                    </div>
                  </div>
                </React.Fragment>
              )}
            </React.Fragment>
          ) : (
            ProviderContactData?.is_client_pay_licence ? step == 0 : step == 1
          ) ? (
            <div id={firstStep}>
              <div className="mb-5">
                <h4 className="text-blue-800 text-base font-bold">
                  Compliance checklist
                </h4>
                <p className="text-gray-700">
                  The Compliance checklist ensures that you meet all the
                  necessary requirements set by the client, allowing you to
                  demonstrate your compliance with their specified guidelines
                  and regulations.
                </p>
              </div>
              <div className="flex flex-col gap-5">
                {combinedProvCheckDoc?.map((item, index) => {
                  return (
                    <React.Fragment>
                      <div
                        className="flex justify-between bg-gray-50 p-5 rounded-xl border border-gray-200"
                        key={index}
                      >
                        <Accordion
                          open={open === item?.checklist_doc_id}
                          icon={
                            <Icon id={item?.checklist_doc_id} open={open} />
                          }
                        >
                          <div className="flex justify-between">
                            <h4 className="text-gray-700 font-bold ">
                              {index + 1}. {` ${item?.document_type?.doc_type_name}`}
                            </h4>
                            <div className="flex ml-auto gap-3 items-center">
                              <Button
                                className="flex  text-xs items-center text-blue-700 font-semibold gap-2"
                                onClick={() =>
                                  handleOpen(item?.checklist_doc_id)
                                }
                              >
                                Upload{" "}
                                <svg
                                  width="21"
                                  height="21"
                                  viewBox="0 0 21 21"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M17.583 3H2.58301M15.083 11.3333L10.083 6.33333M10.083 6.33333L5.08301 11.3333M10.083 6.33333V18"
                                    stroke="#5786CC"
                                    stroke-width="1.66667"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              </Button>
                            </div>
                          </div>

                          <AccordionBody className="grid-cols-2 grid gap-2">
                            <div className="p-4 rounded-xl border border-gray-300 flex items-center justify-between w-full col-span-full mb-2">
                              {complianceData["doc" + index] == "" && (
                                <Upload
                                  value={""}
                                  showList={false}
                                  onChange={(e) => {
                                    handleForm(e, "doc", index);
                                  }}
                                  className="w-full"
                                >
                                  <div className="text-center">
                                    <div className="flex items-center justify-center flex-col cursor-pointer">
                                      {" "}
                                      <span className="flex w-9 h-9 items-center justify-center rounded-full bg-gray-200 outline outline-8 outline-gray-50 outline-offset-0">
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M6.667 13.333 10 10m0 0 3.333 3.333M10 10v7.5m6.666-3.548a4.583 4.583 0 0 0-2.917-8.12.516.516 0 0 1-.444-.25 6.25 6.25 0 1 0-9.816 7.58"
                                            GetProviderChecklistByClientstroke="#475467"
                                            strokeWidth="1.667"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          ></path>
                                        </svg>
                                      </span>
                                      <span className="pt-4 cursor-pointer">
                                        <span className="text-blue-700 font-semibold mr-1 cursor-pointer">
                                          Click to upload
                                        </span>{" "}
                                        <span className="text-xs text-gray-600 cursor-pointer">
                                          {" "}
                                          or drag and drop ( max. 25mb)
                                        </span>
                                      </span>
                                    </div>
                                  </div>
                                  {/* {sizeError && (
                                      <div className="text-red-500 text-sm mt-1">
                                        {sizeError}
                                      </div>
                                    )} */}
                                </Upload>
                              )}
                              {complianceData["doc" + index] != "" && (
                                <React.Fragment>
                                  <div className="flex  gap-4">
                                    <span className="w-9 h-9 rounded-full border-4 border-blue-50 bg-blue-200 flex justify-center items-center">
                                      <img
                                        src="/assets/icons-svg/upload-pdf.svg"
                                        alt=""
                                      />
                                    </span>
                                    <div className="flex flex-col justify-center">
                                      <span className="text-gray-700 text-xs font-medium">
                                        {complianceData["doc" + index]?.name}
                                      </span>
                                    </div>
                                  </div>

                                  <button
                                    onClick={(e) => {
                                      handleDeletePDF(e, "doc", index);
                                    }}
                                  >
                                    <svg
                                      width="20"
                                      height="19"
                                      viewBox="0 0 24 25"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M9 3.5h6m-12 3h18m-2 0-.701 10.52c-.105 1.578-.158 2.367-.499 2.965a3 3 0 0 1-1.298 1.215c-.62.3-1.41.3-2.993.3h-3.018c-1.582 0-2.373 0-2.993-.3A3 3 0 0 1 6.2 19.985c-.34-.598-.394-1.387-.499-2.966L5 6.5m5 4.5v5m4-5v5"
                                        stroke="#344054"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </button>
                                </React.Fragment>
                              )}
                            </div>
                            <div className="mb-5">
                              <label className="font-medium text-gray-700">
                                Document name
                              </label>
                              <div className="flex gap-2.5 mt-1">
                                <ClientInput
                                  name={"doc_name"}
                                  inputchangehandler={(e) =>
                                    handleForm(e, "doc_name", index)
                                  }
                                  className="w-full h-10 select-options"
                                />
                              </div>
                            </div>
                            {item?.document_type?.req_issuer && (
                              <div className="mb-4">
                                <label className="font-medium text-gray-700">
                                  Issuing authority
                                </label>
                                <div className="flex gap-2.5 mt-1">
                                  <ClientInput
                                    name={"req_issuer"}
                                    inputchangehandler={(e) =>
                                      handleForm(e, "req_issuer", index)
                                    }
                                    className="w-full h-10 select-options"
                                  />
                                </div>
                              </div>
                            )}

                            {item?.document_type?.req_policy_no && (
                              <div className="mb-4">
                                <label className="font-medium text-gray-700">
                                  Policy number
                                </label>
                                <div className="flex gap-2.5 mt-1">
                                  <ClientInput
                                    name={"req_policy_no"}
                                    inputchangehandler={(e) =>
                                      handleForm(e, "req_policy_no", index)
                                    }
                                    className="w-full h-10 select-options"
                                  />
                                </div>
                              </div>
                            )}
                            {item?.document_type?.req_amount_insured && (
                              <div className="mb-4">
                                <label className="font-medium text-gray-700">
                                  Amount insured
                                </label>

                                <div className="flex">
                                  <div className="w-full relative">
                                    <span className="adon_icon absolute left-2 top-10px">
                                      <svg
                                        width="16"
                                        height="17"
                                        viewBox="0 0 20 21"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M5 13.789a3.333 3.333 0 0 0 3.333 3.333h3.334a3.333 3.333 0 0 0 0-6.667H8.333a3.333 3.333 0 1 1 0-6.666h3.334A3.333 3.333 0 0 1 15 7.122m-5-5V18.79"
                                          stroke="#667085"
                                          strokeWidth="1.667"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </span>
                                    <div className="w-full">
                                      <ClientInput
                                        type={"number"}
                                        placeholder="Enter value here"
                                        name={"req_amount_insured"}
                                        inputchangehandler={(e) =>
                                          handleForm(
                                            e,
                                            "req_amount_insured",
                                            index
                                          )
                                        }
                                        className="w-full h-10 select-options pl-8"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {item?.document_type?.allow_expiry && (
                              <div className="mb-4">
                                <label className="font-medium text-gray-700">
                                  Expiry date
                                </label>
                                <div className="mt-1 w-full">
                                  <DatePicker
                                    onChange={(e) =>
                                      handleForm(e, "allow_expiry", index)
                                    }
                                    placeholder="Select expiry date"
                                    minDate={minDate}
                                  />
                                </div>
                              </div>
                            )}
                            {item?.document_type?.req_expiry_date_notes && (
                              <div className="mb-4">
                                <label className="font-medium text-gray-700">
                                  Additional info
                                </label>
                                <div className="flex gap-2.5 mt-1">
                                  <textarea
                                    name={"req_expiry_date_notes"}
                                    onChange={(e) =>
                                      handleForm(
                                        e,
                                        "req_expiry_date_notes",
                                        index
                                      )
                                    }
                                    rows={4}
                                    cols={40}
                                    placeholder="."
                                    className="moduleDescTextarea input-shadow text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-900 leading-tight focus:outline-none focus:shadow-outline h-10"
                                  />
                                </div>
                              </div>
                            )}
                            {item?.document_type?.custom_fields &&
                              Object.values(
                                item?.document_type?.custom_fields
                              )?.map((item, customIndex) => {
                                return (
                                  <div className="mb-4" key={customIndex}>
                                    <label className="font-medium text-gray-700">
                                      {item}
                                    </label>
                                    <div className="flex gap-2.5 mt-1">
                                      {/* <input
                                          type="text"
                                          className="input-shadow h-10 text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-900 leading-tight focus:outline-none focus:shadow-outline"
                                        /> */}
                                      <ClientInput
                                        name={item}
                                        inputchangehandler={(e) =>
                                          handleForm(
                                            e,
                                            "doctype_fields_data",
                                            index,
                                            item,
                                            customIndex
                                          )
                                        }
                                        className="w-full h-10 select-options"
                                      />
                                    </div>
                                  </div>
                                );
                              })}
                          </AccordionBody>
                        </Accordion>
                      </div>
                    </React.Fragment>
                  );
                })}
                {combinedProvCheckDoc.length == 0 && (
                  <div className="h-full w-full text-center mt-2 mb-2">
                    No data available
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div id={secondStep}>
              <div className="mb-5">
                <h4 className="text-blue-800 text-base font-bold">
                  Assign workers
                </h4>
                <p className="text-gray-700">
                  You will need to customise your workforce by choosing the
                  right workers to be assigned to the client. Keep in mind that
                  workers must complete the client's induction modules and
                  provide the requested documents as specified by the client.
                </p>
              </div>
              
              <div className="flex items-center mb-1">
                <label className="font-medium text-gray-700 block ">
                  Workers
                </label>
                <span
                  className={
                    "badge tag text-warning-700 bg-warning-50 py-0.5 px-2 rounded-full font-medium ml-2"
                  }
                >
                  {ProviderContactData?.is_client_pay_licence == true
                    ? totalWorker
                    : `${totalWorker}/${seatCount}`} assigned
                </span>
              </div>
           
              {addWorkerData?.workersInviteData?.map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    <div className="py-2">
                      <label className="font-medium text-gray-700 block mb-1 mt-2">
                        Email*
                      </label>
                      <div className="flex gap-2 items-center">
                        <div className="w-full">
                          <Select
                            isSearchable={true}
                            placeholder="Search for a worker"
                            className="w-full h-10 select-options"
                            isClearable={true}
                            options={updatedOptions || searchOptions}
                            value={{
                              label: item?.first_name
                                ? item?.email
                                : item.label
                                  ? item.label
                                  : "",
                              email: item?.email,
                              individual_id: item?.individual_id,
                              is_conserve_team: item?.is_conserve_team,
                              invite_id: item?.invite_id,
                            }}
                            onChange={(e) => handleSelectChange(e, index)}
                            handleSearchChange={inputchangehandler2}
                          />
                        </div>

                        {addWorkerData?.workersInviteData.length > 1 && (
                          <Button onClick={() => DeleteWorker(index)}>
                            <svg
                              width="19"
                              height="20"
                              viewBox="0 0 24 25"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 3.5h6m-12 3h18m-2 0-.701 10.52c-.105 1.578-.158 2.367-.499 2.965a3 3 0 0 1-1.298 1.215c-.62.3-1.41.3-2.993.3h-3.018c-1.582 0-2.373 0-2.993-.3A3 3 0 0 1 6.2 19.985c-.34-.598-.394-1.387-.499-2.966L5 6.5m5 4.5v5m4-5v5"
                                stroke="#667085"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                            </svg>
                          </Button>
                        )}
                      </div>
                      <div className="flex flex-row gap-1 mt-1">
                        {errorValidation[`alreadyWorkerError_${index}`] && (
                          <div className="text-red-500 text-sm">
                            {errorValidation[`alreadyWorkerError_${index}`]}
                          </div>
                        )}

                        {!errorValidation[`alreadyWorkerError_${index}`] &&
                          errorValidation[`conserveTeamError_${index}`] && (
                            <div className="text-red-500 text-sm">
                              {errorValidation[`conserveTeamError_${index}`]}
                            </div>
                          )}

                        {!errorValidation[`alreadyWorkerError_${index}`] &&
                          !errorValidation[`conserveTeamError_${index}`] &&
                          errorValidation[`emailError_${index}`] && (
                            <div className="text-red-500 text-sm">
                              {errorValidation[`emailError_${index}`]}
                            </div>
                          )}

                        {!errorValidation[`alreadyWorkerError_${index}`] &&
                          !errorValidation[`conserveTeamError_${index}`] &&
                          !errorValidation[`emailError_${index}`] &&
                          errorValidation[`alreadyInvitedError_${index}`] && (
                            <div className="text-red-500 text-sm">
                              {errorValidation[`alreadyInvitedError_${index}`]}
                            </div>
                          )}
                      </div>

                      <div className="flex gap-2 mt-2">
                        <div className="w-3/6 ">
                          <label className="font-medium text-gray-700 block mb-1">
                            First name*
                          </label>
                          <ClientInput
                            name="first_name"
                            readOnly={item?.individual_id ? true : false}
                            inputchangehandler={(e) => {
                              formHandleData(e, index, "first_name");
                            }}
                            value={item.first_name}
                            className="h-9 w-full"
                            placeholder="Enter contact's first name"
                          />
                          {checkError && !item.first_name && (
                            <div className="text-red-500 text-sm mt-1 ">
                              This field is required!
                            </div>
                          )}
                        </div>
                        <div className=" w-3/6">
                          <label className="font-medium text-gray-700 block mb-1">
                            Last name*
                          </label>
                          <ClientInput
                            name="last_name"
                            readOnly={item?.individual_id ? true : false}
                            inputchangehandler={(e) => {
                              formHandleData(e, index, "last_name");
                            }}
                            value={item.last_name}
                            className="h-9 w-full"
                            placeholder="Enter contact's last name"
                          />
                          {checkError && !item.last_name && (
                            <div className="text-red-500 text-sm mt-1 ">
                              This field is required!
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                );
              })}

              {!ProviderContactData?.is_client_pay_licence && totalWorker >= seatCount && (
                <div className="mb-3">
                  <span
                    className={
                      "badge text-error-700 py-0 px-0 rounded-full font-medium"
                    }
                  >
                    You have reached your worker limit. Please purchase additional seats.
                  </span>
                </div>
              )}

              {ProviderContactData?.is_client_pay_licence == false && totalWorker < seatCount && (
                <button
                  type="button"
                  disabled={
                    totalWorker >= seatCount || (subscriptionStatus == "expired" && true)
                  }
                  className="text-blue-700 text-xs font-semibold flex items-center gap-2 mt-5"
                  onClick={addWorker}
                >
                  <span>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 4.167v11.666M4.167 10h11.666"
                        stroke="#5786CC"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </span>
                  Add another Worker
                </button>
              )}

              {ProviderContactData?.is_client_pay_licence && (
                <button
                  type="button"
                  disabled={
                    (subscriptionStatus == "expired" && true)
                  }
                  className="text-blue-700 text-xs font-semibold flex items-center gap-2 mt-5"
                  onClick={addWorker}
                >
                  <span>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 4.167v11.666M4.167 10h11.666"
                        stroke="#5786CC"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </span>
                  Add another Worker
                </button>
              )}
            </div>
          )}
        </div>
        {/* {checkError && (
          <div className="flex flex-column">
            <p className="text-xs text-red-600 mt-2 ml-5">
              {"All field's are required!"}
            </p>
          </div>
        )} */}
        <div className="flex dailog-footer gap-2 justify-end">
          <BtnLight
            className="w-auto px-4"
            onClick={onPrevious}
            disabled={step === 0}
          >
            Cancel
          </BtnLight>
          {/* <BtnPrimaryLight className="w-auto px-4">
            Save and continue another time
          </BtnPrimaryLight> */}
          {
            <BtnPrimary
              className="w-auto px-4"
              type="button"
              disabled={
                // Step-based disabling logic with client-paid override
                step === 0
                  ? (
                    clientPays
                      // For client-paid flow, the initial screen can be compliance; don't gate on agree/card
                      ? isProcessing
                      : (
                        // On provider-paid payment step: if total is zero, allow continue unless processing
                        (Number(paymentData?.amount || 0) === 0 && (Number(paymentData?.licence_fee || 0) + Number(paymentData?.worker_amount || 0)) === 0)
                          ? isProcessing
                          : (!agree || isProcessing || cardExpiredOrNot)
                      )
                  )
                  : (
                    // On compliance and subsequent steps: only block while processing
                    isProcessing
                  )
              }
              onClick={() => onNext(step)}
              // disabled={step === 0}
              variant="solid"
            >
              {step === 0 ? (
                <span className="flex justify-center">
                  {isProcessing ? <ThreeDotLoader /> : " Continue"}
                  <img
                    src="/assets/icons-svg/arrow-right.svg"
                    alt=""
                    className="ml-2"
                  />{" "}
                </span>
              ) : step === 1 ? (
                <span className="flex justify-center">
                  {ProviderContactData?.is_client_pay_licence ? (
                    isProcessing ? (
                      <ThreeDotLoader />
                    ) : (
                      "Complete"
                    )
                  ) : isProcessing ? (
                    <ThreeDotLoader />
                  ) : (
                    " Continue"
                  )}
                  <img
                    src="/assets/icons-svg/arrow-right.svg"
                    alt=""
                    className="ml-2"
                  />{" "}
                </span>
              ) : (
                <span>{isProcessing ? <ThreeDotLoader /> : " Complete"}</span>
              )}
            </BtnPrimary>
          }
          {/* <BtnPrimary className="w-auto px-6" onClick={handleSubmit}>
            Confirm and pay
          </BtnPrimary> */}
        </div>
      </form>
      {/* --------- provider Subscription expired message--------  */}
      <Dialog
        isOpen={providerSubExpired}
        onClose={closeProviderExpiredDialog}
        onRequestClose={closeProviderExpiredDialog}
        className="customAlert"
      >
        <div className="px-6 pt-6">
          <span className="w-12 h-12 rounded-full m-auto bg-error-100 flex items-center justify-center">
            <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.894531" y="0.586914" width="48" height="48" rx="24" fill="#D1FADF" />
              <path d="M26.8945 14.8564V18.987C26.8945 19.547 26.8945 19.8271 27.0035 20.041C27.0994 20.2291 27.2524 20.3821 27.4405 20.478C27.6545 20.587 27.9345 20.587 28.4945 20.587H32.6251M21.8945 28.5869L23.8945 30.5869L28.3945 26.0869M26.8945 14.5869H21.6945C20.0144 14.5869 19.1743 14.5869 18.5326 14.9139C17.9681 15.2015 17.5091 15.6605 17.2215 16.2249C16.8945 16.8667 16.8945 17.7068 16.8945 19.3869V29.7869C16.8945 31.4671 16.8945 32.3071 17.2215 32.9489C17.5091 33.5134 17.9681 33.9723 18.5326 34.2599C19.1743 34.5869 20.0144 34.5869 21.6945 34.5869H28.0945C29.7747 34.5869 30.6148 34.5869 31.2565 34.2599C31.821 33.9723 32.2799 33.5134 32.5676 32.9489C32.8945 32.3071 32.8945 31.4671 32.8945 29.7869V20.5869L26.8945 14.5869Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
          <p className="text-base text-gray-900 font-semibold text-center mt-4 mb-1">
            Your subscription has expired. Please renew your plan to continue accessing all features!
          </p>

        </div>
        <div className="mt-8 flex justify-between pb-6 px-6  gap-3">

          <BtnPrimary
            variant="solid"
            onClick={closeProviderExpiredDialog}
          >
            {"Close"}
          </BtnPrimary>
        </div>
      </Dialog>
    </React.Fragment>
  );
};

export default InviteClientPaymentExistUser;
